import { useCheckRole } from '@ospace/auth'
import { CampaignLayout } from '@ospace/campaign'
import { useCampaign } from '@ospace/campaign/hooks'
import { userTypes } from '@ospace/core-auth'
import { PageTitle } from '@ospace/layout'
import { ErrorBoundary, showNotification } from '@ospace/shared'
import { Formik } from 'formik'
import { useRef } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'

import { ContactUploadForm } from '../components/ContactForm'
import { inits, uploadContactSchema } from '../components/UploadContactHelper'
import { ContactService } from '../services'

type Props = {
  campaignId: number
}
export const ContactUploadPage = (props: Props) => {
  const queryClient = useQueryClient()
  const payload = useRef({})
  const navigate = useNavigate()
  const { data: campaign } = useCampaign(props.campaignId)
  const mutation = useMutation(
    (contact: any) => {
      contact.campaignId = props.campaignId
      contact.lookerClientId = campaign?.lookerClientId
      return ContactService.validateContact(contact)
    },
    {
      onSuccess: (data) => {
        showNotification({
          message: 'Please review your contacts before uploading.',
          type: 'success',
        })
        navigate(`/campaign/${props.campaignId}/contact/review`, {
          state: {
            data,
            payload: payload.current,
          },
        })
        queryClient.invalidateQueries(['contacts', props.campaignId])
      },
      onError: (e: any) => {
        showNotification({
          message: e.response?.data || e.message,
          type: 'error',
        })
      },
    }
  )

  const handleSubmit = async (values: any, actions: any) => {
    payload.current = values
    await mutation.mutateAsync(values as any)
    actions.resetForm()
  }

  return (
    <CampaignLayout>
      <PageTitle>Upload Contacts</PageTitle>
      <div className='card'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-3 mb-1'>Upload Contacts CSV</span>
          </h3>
        </div>
        <Formik
          initialValues={inits}
          validationSchema={uploadContactSchema}
          onSubmit={handleSubmit}
        >
          {(formProps) => (
            <ContactUploadForm
              form={formProps}
              mutation={mutation}
              cancelLink={`/campaign/view/${props.campaignId}`}
            />
          )}
        </Formik>
      </div>
    </CampaignLayout>
  )
}

const Controller = () => {
  useCheckRole([userTypes.Admin, userTypes.ClientManager, userTypes.CampaignManager])
  const params: any = useParams()
  return <ContactUploadPage campaignId={params?.id} />
}

export const ContactUploadPageRouteHandler = () => (
  <ErrorBoundary>
    <Controller />
  </ErrorBoundary>
)
